import { useParams, useSelectedLayoutSegment } from 'next/navigation';
import { useEffect, useState } from 'react';
import { getProfile } from '~/api';
import { ProfileExpanded } from '~/types';

export function useProfileFromPage() {
  const segment = useSelectedLayoutSegment();
  const isProfilePage = segment === '(profile)';
  const { username } = useParams<{ username: string }>();
  const [profile, setProfile] = useState<ProfileExpanded | null>(null);

  useEffect(() => {
    const fn = async () => {
      if (!isProfilePage) {
        setProfile(null);

        return;
      }
      const { profile } = await getProfile({ username });

      setProfile(profile);
    };

    fn();
  }, [username, isProfilePage]);

  return {
    isProfilePage,
    username,
    profile,
  };
}
